import PrefixPath from "../config/AppConfig";

export const BaseUrl  =  PrefixPath.API_BASE_URL;
export const HubBaseUrl  =  PrefixPath.HUB_API_BASE_URL;